'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { ExternalLink, ChevronLeft } from 'lucide-react'
import TeachingModeToggle from './TeachingModeToggle'

// Top bar only. Navigation lives in AdminSidebar (≥768px) and AdminTabBar
// (<768px), so this header intentionally does NOT duplicate those links.
// Left: brand (back chevron when not on /admin).
// Right: ⌘K hint · teaching mode · 檢視前台 (desktop); external-link icon (mobile).

export default function AdminHeader() {
  const pathname = usePathname()
  const isHome = pathname === '/admin'

  return (
    <header className="admin-nav">
      <div className="admin-nav__inner">
        <Link
          href="/admin"
          className="admin-nav__brand shrink-0 inline-flex items-center gap-1"
          aria-label={isHome ? '咪室後台' : '返回後台總覽'}
        >
          {!isHome && (
            <ChevronLeft size={18} strokeWidth={2} aria-hidden="true" style={{ marginLeft: -4 }} />
          )}
          <span>咪室後台</span>
        </Link>

        {/* Desktop action cluster */}
        <div className="hidden md:inline-flex items-center gap-2 shrink-0 ml-auto">
          <button
            type="button"
            className="admin-cmd-hint-badge"
            data-tour="command-palette"
            aria-label="開啟快速搜尋 (⌘K)"
            onClick={() => {
              window.dispatchEvent(
                new KeyboardEvent('keydown', { key: 'k', metaKey: true, bubbles: true })
              )
            }}
          >
            <kbd>⌘K</kbd>
            <span>搜尋</span>
          </button>
          <TeachingModeToggle />
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="admin-nav__link inline-flex items-center gap-1.5"
            style={{ color: 'var(--admin-text-secondary)' }}
            aria-label="在新分頁開啟前台網站"
            title="在新分頁開啟前台"
          >
            <ExternalLink size={14} strokeWidth={2} aria-hidden="true" />
            <span>檢視前台</span>
          </a>
        </div>

        {/* Mobile: 檢視前台 icon only (sidebar/tabbar handle nav) */}
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className="md:hidden inline-flex items-center justify-center ml-auto"
          style={{
            width: 44,
            height: 44,
            color: 'var(--admin-text-primary)',
            textDecoration: 'none',
          }}
          aria-label="在新分頁開啟前台網站"
          title="在新分頁開啟前台"
        >
          <ExternalLink size={20} strokeWidth={1.75} aria-hidden="true" />
        </a>
      </div>
    </header>
  )
}
